/* Rod Armour — cp-scrolling-announcement marquee hydrator (Opus 4.7 12-May)
   Now uses shared .ra-ann classes (no section-id scoping). Per-instance state
   lives on the root element via dataset; CSS custom properties on the inline
   style attribute provide the visual tuning. */
(function () {
  function initMarquee(root) {
    if (root.dataset.cpAnnHydrated === 'true') return;
    root.dataset.cpAnnHydrated = 'true';

    var sid = root.dataset.sectionId || '';
    var viewport = root.querySelector('[data-ann-viewport]');
    var track = root.querySelector('[data-ann-track]');
    var groups = root.querySelectorAll('[data-ann-group]');
    if (!viewport || !track || groups.length < 2) return;

    var sourceGroup = groups[0];
    var mirrorGroup = groups[1];
    var originalItems = Array.prototype.slice.call(sourceGroup.children).map(function (item) {
      return item.cloneNode(true);
    });
    var deferredSync = root.dataset.deferAnimation === 'true';
    var synced = false;
    if (!originalItems.length) return;

    function syncTrack() {
      synced = true;
      var maxLoops = 16;
      var loops = 0;
      while (sourceGroup.scrollWidth < viewport.offsetWidth + 48 && loops < maxLoops) {
        originalItems.forEach(function (item) {
          sourceGroup.appendChild(item.cloneNode(true));
        });
        loops += 1;
      }
      mirrorGroup.innerHTML = sourceGroup.innerHTML;
      root.style.setProperty('--ra-ann-distance', sourceGroup.scrollWidth + 'px');
    }

    function ensureTrackSync() {
      if (synced) return;
      syncTrack();
    }

    if (!deferredSync) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncTrack, { once: true });
      } else {
        syncTrack();
      }
    }

    if (deferredSync && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var activated = false;
      var passiveOpts = { passive: true };
      var activate = function () {
        if (activated) return;
        activated = true;
        ensureTrackSync();
        root.classList.add('ra-ann--animated');
        window.removeEventListener('scroll', activate, passiveOpts);
        window.removeEventListener('touchstart', activate, passiveOpts);
        window.removeEventListener('pointerdown', activate, passiveOpts);
        window.removeEventListener('keydown', activate);
      };
      window.addEventListener('scroll', activate, passiveOpts);
      window.addEventListener('touchstart', activate, passiveOpts);
      window.addEventListener('pointerdown', activate, passiveOpts);
      window.addEventListener('keydown', activate);
    }

    window.addEventListener('resize', function () {
      if (deferredSync && !synced) return;
      syncTrack();
    });
    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.detail && event.detail.sectionId === sid) {
        if (deferredSync && !synced) return;
        syncTrack();
      }
    });
  }

  function hydrateAll() {
    document.querySelectorAll('[data-cp-scrolling-announcement]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateAll);
  } else {
    hydrateAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section) return;
    section.querySelectorAll('[data-cp-scrolling-announcement]').forEach(initMarquee);
  });
})();
